module.exports = __webpack_public_path__ + "media/flags/cm-81d87baa.svg";